import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '..';

const selectUsersState = (state: RootState) => state.users;

export const selectAllManagedUsers = createSelector(
  [selectUsersState],
  (state) => state.users,
);

export const selectUsersLoading = createSelector(
  [selectUsersState],
  (state) => state.isLoading,
);

export const selectUsersCreating = createSelector(
  [selectUsersState],
  (state) => state.isCreating,
);

export const selectUserStatusUpdatingId = createSelector(
  [selectUsersState],
  (state) => state.statusUpdatingUserId,
);

export const selectUsersError = createSelector(
  [selectUsersState],
  (state) => state.error,
);

export const selectActiveManagedUsers = createSelector(
  [selectAllManagedUsers],
  (users) => users.filter((user) => user.is_active),
);

export const selectInactiveManagedUsers = createSelector(
  [selectAllManagedUsers],
  (users) => users.filter((user) => !user.is_active),
);

export const selectManagedUsersGroupedByOutlet = createSelector(
  [selectAllManagedUsers],
  (users) => {
    const groups = new Map<
      string,
      { outletId: string | null; outletName: string; users: typeof users }
    >();

    users.forEach((user) => {
      const outletName = user.outlet_name || 'Unassigned Outlet';
      const existing = groups.get(outletName);
      if (existing) {
        existing.users.push(user);
        return;
      }

      groups.set(outletName, {
        outletId: user.outlet_id,
        outletName,
        users: [user],
      });
    });

    return Array.from(groups.values()).sort((left, right) =>
      left.outletName.localeCompare(right.outletName),
    );
  },
);

export const selectUserRoleMetrics = createSelector(
  [selectUsersState],
  (state) => state.metrics,
);

export const selectUserRoleMetricsLoading = createSelector(
  [selectUsersState],
  (state) => state.isMetricsLoading,
);
